import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddColumnBefore = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.25006 7.25006C1.97392 7.25006 1.75006 7.47392 1.75006 7.75006C1.75006 8.0262 1.97392 8.25006 2.25006 8.25006H4.75006L4.75006 10.7501C4.75006 11.0262 4.97392 11.2501 5.25006 11.2501C5.5262 11.2501 5.75006 11.0262 5.75006 10.7501L5.75006 8.25006H8.25006C8.5262 8.25006 8.75006 8.0262 8.75006 7.75006C8.75006 7.47392 8.5262 7.25006 8.25006 7.25006H5.75006L5.75006 4.75006C5.75006 4.47392 5.5262 4.25006 5.25006 4.25006C4.97392 4.25006 4.75006 4.47392 4.75006 4.75006L4.75006 7.25006L2.25006 7.25006ZM11.2501 11.25V13.25L13.2501 13.25V11.25H11.2501ZM10.2501 11.25V10.25L10.2501 8.25V7.25V5.25V4.25V2.25C10.2501 1.69771 10.6978 1.25 11.2501 1.25H13.2501C13.8023 1.25 14.2501 1.69772 14.2501 2.25V4.25V5.25V7.25V8.25L14.2501 10.25V11.25V13.25C14.2501 13.8023 13.8023 14.25 13.2501 14.25H11.2501C10.6978 14.25 10.2501 13.8023 10.2501 13.25V11.25ZM13.2501 4.25V2.25H11.2501V4.25H13.2501ZM11.2501 5.25H13.2501V7.25H11.2501V5.25ZM11.2501 10.25L11.2501 8.25H13.2501L13.2501 10.25H11.2501Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AddColumnBefore
